export async function fetchLsResult({ id, token }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/getLsResult`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ id }),
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || "Failed to fetch result");
  }

  return resp.json();
}
